module.exports = __webpack_public_path__ + "img/49_12.bc5e648a.png";